import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IUserEmailNotification } from 'src/app/modules/admin/models';

@Component({
  selector: 'app-email-body-dialog',
  templateUrl: './email-body-dialog.component.html',
  styleUrls: ['./email-body-dialog.component.scss']
})
export class EmailBodyDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: IUserEmailNotification) { }
    

  ngOnInit(): void {
  }

}
